import React from "react";
import { normalizeProps } from "./utils/normalizeProps";

const PacswebIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...normalizeProps(props)}
    >
      <path
        d="M6.99414 5.75C6.99414 4.7835 7.77764 4 8.74414 4H13.4932C16.3164 4 18.2441 6.33994 18.2441 8.75C18.2441 11.159 16.3191 13.4999 13.4941 13.4999H10.4941L10.4941 18.25C10.4941 19.2165 9.71064 20 8.74414 20C7.77764 20 6.99414 19.2165 6.99414 18.25L6.99414 5.75ZM10.4941 9.99994H13.4941C14.2092 9.99994 14.7441 9.40784 14.7441 8.75C14.7441 8.0932 14.2084 7.5 13.4932 7.5H10.4941V9.99994Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PacswebIcon;
